import React from 'react'
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { useDispatch, useSelector } from 'react-redux'
import { Grid, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import CachedIcon from '@mui/icons-material/Cached';
import {obtenerlistadepta } from '../../../Redux/DepartamentosDucks'
const SelectDepartamento = (props) => {
    const dispatch = useDispatch()
    const { dep } = props;
    const { obtenerDeptahijo } = props;
    const { bd } = props
    const depta = useSelector(store => store.depta.deptadata)
    const handleChange2 = (event) => {
        obtenerDeptahijo(event.target.value)
    };
    const handleChangelistadepta = (event,bd) => {
        dispatch(obtenerlistadepta(props.bd))
    };
    return (
        <Grid container alignItems="center" justifyContent="center" flexDirection='column'>
            <Grid item md={5} >
                <Typography variant='h3'>
                    Selección de nomina
                </Typography>
            </Grid>
            <Grid item md={5} >
                <Typography variant='h6'>
                    Selecciona la ubicación de la nomina para capturar incidencias
                </Typography>
            </Grid>

            <Grid item md={10} component={Paper} variant="outlined" padding={5}>

                <Typography variant="h6" >
                    Selecciona  el tipo de nomina
                    <Tooltip title="Actualizar lista">
                        <IconButton aria-label="delete"  onClick={(e)=>handleChangelistadepta()}>
                            <CachedIcon />
                        </IconButton>
                    </Tooltip>
                </Typography>
                <FormControl variant="standard" sx={{ m: 2, minWidth: 300 }} fullWidth>
                    <InputLabel id="demo-simple-select-filled-label">Departamento</InputLabel>

                    <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={dep === -1 ? '' : dep}
                        onChange={handleChange2}
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        {depta.map((row2, Index) => (
                            <MenuItem key={Index} value={row2}>{row2.descripcion}</MenuItem>
                        ))}

                    </Select>


                </FormControl>

            </Grid>
        </Grid>
    )
}

export default SelectDepartamento